// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"jeBd_"};